<!--
 * @Author: xiaokun
 * @Date: 2020-03-06 13:35:45
 * @LastEditors: xiaokun
 * @LastEditTime: 2020-03-10 11:48:21
 * @Description: 创建编辑活码时，右侧预览组件
 -->
<template>
  <div
    v-loading="loading"
    class="code-preview"
  >
    <iframe
      :src="iframeSrc"
      class="preview-iframe"
      frameborder="0"
      @load="iframeOnLoad"
    />
  </div>
</template>
<script>
export default {
  name: 'CodePreview',
  components: {},
  props: {
    // iframe的地址
    iframeSrc: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      loading: true,
      previewIframeDom: null
    }
  },
  methods: {
    // iframe加载完成回调
    iframeOnLoad () {
      this.loading = false
      this.previewIframeDom = document.querySelector('.preview-iframe')
      this.$emit('iframe-loaded', this.previewIframeDom)
    }
  }
}
</script>
<style lang='scss' scoped>
.code-preview {
  width: 205px;
  height: 325px;
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.13);

  .preview-iframe {
    height: 100%;
    width: 100%;
  }
}
</style>
